import {PayloadAction} from "@reduxjs/toolkit";
import {Reducer} from "redux";
import {
  NODE_PERMISSIONS_CONFIG_CLEAR,
  NODE_PERMISSIONS_CONFIG_FETCH,
  NODE_PERMISSIONS_CONFIG_SEND
} from "./nodePermissionsConfigActions";
import {REQUEST_SUCCESS} from "../../middlewares/request/requestActions";
import {getIsUserSuperadmin} from "../../utils/permissions";

export type NodePermissionsConfigState = {
  permissions: any[] | null;
};

const nodePermissionsConfigReducer: Reducer<NodePermissionsConfigState, PayloadAction<any>> = (
  state = {
    permissions: null
  },
  action
) => {
  switch (action.type) {
    case NODE_PERMISSIONS_CONFIG_CLEAR: {
      return {
        ...state,
        permissions: null
      };
    }
    case REQUEST_SUCCESS: {
      switch (action.payload.label) {
        case NODE_PERMISSIONS_CONFIG_FETCH: {
          return {
            ...state,
            permissions: action.payload.response.filter((user: any) => !getIsUserSuperadmin(user))
          };
        }
        case NODE_PERMISSIONS_CONFIG_SEND:
          return {
            ...state,
            permissions: null
          };
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default nodePermissionsConfigReducer;
